import SafeRenderHtml from 'CampaignVolunteer/components/SafeRenderHtml'

export default function MonthlyUpsellPage({ config, amount, setMonthly, coverFee, setCoverFee, coverFeeAmount, handleBack, handleSubmit }) {

    const displayAmount = (val) => val % 100 === 0 ?
      (val / 100).toFixed(0) :
      (val / 100).toFixed(2);
  
    const upsellText = useMemo(() => config.monthlyUpsellText.replace(/{{( ?)(value|amount)( ?)}}/g, '£' + displayAmount(amount)), [config.monthlyUpsellText, amount]);
    const monthlyUpsellButton = useMemo(() => config.monthlyUpsellButton.replace(/{{( ?)(value|amount)( ?)}}/g, '£' + displayAmount(amount)), [config.monthlyUpsellButton, amount]);
    const oneOffButton = useMemo(() => config.oneOffButton.replace(/{{( ?)(value|amount)( ?)}}/g, '£' + displayAmount(amount)), [config.oneOffButton, amount]);
    const coverFeeText = useMemo(() => config.coverFeeText.replace(/{{( ?)fee( ?)}}/g, '£' + displayAmount(coverFeeAmount)), [config.coverFeeText, coverFeeAmount]);
    
    const handleMonthlyUpsell = () => {
      setMonthly(true);
      handleSubmit();
    }

    return <div className="monthly-upsell-page">
      <div className="back-link">
        <a href="#" onClick={handleBack}><SvgIconsArrowLeft variant="light" /><span>Back</span></a>
      </div>
      <div className="progress-bar"></div>
      <h2 className="upsell-header">
        Will you make it monthly?
      </h2>
      <div className="upsell-text">
        <SafeRenderHtml html={upsellText.replace(/\n/g, "<br>")} />
      </div>
      <div className="buttons">
        <button className="monthly-btn" type="button" onClick={handleMonthlyUpsell}>{ monthlyUpsellButton }</button>
        <button className="one-off-btn" type="button" onClick={handleSubmit}>{ oneOffButton }</button>
      </div>

      <div className="cover-fee">
        <label><input type="checkbox" checked={coverFee} onChange={() => setCoverFee(!coverFee)}/><SafeRenderHtml html={coverFeeText} /></label>
      </div>
    </div>
}
